<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="ORIM-Epigraph-1">“… Trust not in the multitudes.</p>
<p class="ORIM-Epigraph">They are always wrong …”</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Meyer_LotusCrew_4P_MD-3.vue?e683da74